import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden';
import styles from './Spinner.module.scss';

interface SpinnerProps {
  size?: number;
  color?: string;
  center?: boolean;
  isMainContent?: boolean;
}

export function Spinner({ size = 36, color, center, isMainContent }: SpinnerProps): React.ReactElement {
  const { t } = useTranslation();
  const inlineStyles: React.CSSProperties = {
    width: `${size}px`,
    height: `${size}px`,
  };

  if (color) {
    inlineStyles.color = color;
  }

  if (isMainContent) {
    return (
      <main className={styles.main}>
        <div className={classNames(styles.spinner, center && styles.center)} style={inlineStyles}>
          {isMainContent && (
            <VisuallyHidden>
              <h1>{t('hidden.loading')}</h1>
            </VisuallyHidden>
          )}
          <svg className={styles.svg} viewBox="22 22 44 44">
            <circle className={styles.circle} cx="44" cy="44" r="20.2" strokeWidth="3.6" />
          </svg>
        </div>
      </main>
    );
  }

  return (
    <div className={classNames(styles.spinner, center && styles.center)} style={inlineStyles}>
      <svg className={styles.svg} viewBox="22 22 44 44">
        <circle className={styles.circle} cx="44" cy="44" r="20.2" strokeWidth="3.6" />
      </svg>
    </div>
  );
}
